// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetProvidersRecommendedProviderItem-moduleitem__uN1CK";
var _2 = "RequestProfileWidgetProvidersRecommendedProviderItem-moduleprovider__UZ3wB";
export { _1 as "item", _2 as "provider" }
